import { EventType } from './eventType';

export class EventTypes {
    eventTypes: EventType[];
}
